export function getDefaultMessageBody(ref: string, customerName: string) {
  return `Dear ${customerName},
We noticed your payment for Invoice #${ref} is past due. 
If you have already made the payment, kindly disregard this reminder. 
Otherwise, please contact us if you need assistance.
  
Best regards,
[Your Name]
[Your Company]`;
}

export function getDefaultMessageSubject(ref: string) {
  return `Past due invoice reminder ${ref}`;
}
